module.exports = __webpack_public_path__ + "static/media/img_landing16.8e79637f.png";